<template>
  <div class="leaflet-map"></div>
</template>

<style>
.easy-button-button span {
   font-size: 16px;
}
.leaflet-marker-icon.tracker {
  pointer-events: none !important;
}
</style>

<script>
import throttle from 'lodash/throttle'
import { mapState, mapMutations } from 'vuex'
import { Map, TileLayer, Polyline, Marker, LatLng, Icon } from 'leaflet'
import { SET_TRACK_CURRENT_IDX } from '@/store/mutation-types'

import startMarkerSVGUrl from '@/assets/start-marker.svg'
import finishMarkerSVGUrl from '@/assets/finish-marker.svg'

require('font-awesome/css/font-awesome.css')
require('leaflet-easybutton/src/easy-button.js')
require('leaflet-easybutton/src/easy-button.css')
require('leaflet-rotatedmarker/leaflet.rotatedMarker.js')

const trackerSVG = `
<svg height="26" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 580 400">
 <g>
  <path vector-effect="non-scaling-stroke" fill="#ff9e00" fill-opacity="0.8" stroke="#ffffff" stroke-width="1" d="m1.5,1.5l578.5,198.5l-580,200l130,-199l-128.5,-199.5z" id="svg_1"/>
  <ellipse fill="#ffffff" cx="193" cy="200" id="svg_4" rx="22" ry="22"/>
 </g>
</svg>
`

function addViewModeSwitch (map) {
  let normalViewButton, centerViewButton, isCenter

  const panTo = throttle((latLng) => {
    map.panTo(latLng)
  }, 2000, { trailing: true })

  /* eslint-disable no-undef */
  normalViewButton = L.easyButton('fa-expand', () => {
    isCenter = false
    map.removeControl(normalViewButton)
    map.addControl(centerViewButton)
  }, 'Normal Mode', '')
  centerViewButton = L.easyButton('fa-dot-circle-o', () => {
    isCenter = true
    map.removeControl(centerViewButton)
    map.addControl(normalViewButton)
  }, 'Center Mode', '')
  /* eslint-enable */

  map.addControl(centerViewButton)

  return (point) => {
    if (isCenter) {
      panTo(point)
    }
  }
}

export default {

  computed: {
    ...mapState({
      url: state => state.track.url,
      color: state => state.track.color,
      points: state => state.track.points,
      currentIdx: state => state.track.current_idx
    })
  },

  methods: {
    ...mapMutations({
      setIdx: SET_TRACK_CURRENT_IDX
    })
  },

  watch: {
    url () {
      this.$store.dispatch('fetchGraph')
    },
    points () {
      let polyline = new Polyline(this.points, {
        color: this.color
      })
      polyline.addTo(this.map)
      this.map.fitBounds(polyline.getBounds())
      let start = new Marker(this.points[0], {
        icon: new Icon({
          iconUrl: startMarkerSVGUrl,
          className: 'start-marker',
          iconSize: [28, 40],
          iconAnchor: [14, 39]
        })
      })
      start.on('click', () => {
        this.setIdx({ idx: 0 })
      })
      start.addTo(this.map)
      let end = new Marker(this.points[this.points.length - 1], {
        icon: new Icon({
          iconUrl: finishMarkerSVGUrl,
          className: 'finish-marker',
          iconSize: [28, 40],
          iconAnchor: [14, 39]
        })
      })
      end.on('click', () => {
        this.setIdx({ idx: this.points.length - 1 })
      })
      end.addTo(this.map)

      this.tracker = new Marker(this.points[0], {
        rotationAngle: 90,
        icon: new Icon({
          iconUrl: 'data:image/svg+xml;base64,' + btoa(trackerSVG),
          className: 'tracker',
          iconSize: [38, 26],
          iconAnchor: [9, 13]
        })
      })
      this.tracker.addTo(this.map)

      polyline.on('click', (evt) => {
        const latLng = evt.latlng
        const distances = this.points.map(el => latLng.distanceTo(new LatLng(el.lat, el.lng)))
        const idx = distances.indexOf(Math.min(...distances))
        this.setIdx({ idx })
      })
    },
    currentIdx () {
      const point = this.points[this.currentIdx]
      this.tracker.setLatLng(point)
      const angle = point.c && point.c[0]
      if (angle !== void 0) {
        this.tracker.setRotationAngle(90 + angle)
      }
      this.updateView(point)
    }
  },

  mounted () {
    this.map = new Map(this.$el, { preferCanvas: true })
    new TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map)
    this.map.setView([48.7670, 9.1761], 14)
    this.updateView = addViewModeSwitch(this.map)
  }
}
</script>




// WEBPACK FOOTER //
// LeafletMap.vue?4b8d717b